export const personalInfo = {
  name: "Mara Martins",
  title: "Especialista em Estratégia de Localização e IA",
  tagline: "Ligando a IA com a linguagem, cultura e tecnologia para ajudar empresas globais a expandirem-se com confiança e impacto.",
  bio: "Com mais de 15 anos em localização, trago uma combinação de gestão de programas, perícia em marketing e inovação em IA — sempre com foco na capacitação de equipas e mentoria da próxima geração de líderes. Resido em Mountain View, Califórnia, EUA.",
  email: "marapt@gmail.com",
  location: "Mountain View, Califórnia, EUA",
  photo: "https://avatars.githubusercontent.com/u/233815337?v=4",
  linkedin: "https://linkedin.com/in/maramartinspt",
  github: "https://github.com/marapt",
  calendly: "https://calendly.com/maramartins"
};

export const services = [
  {
    id: 1,
    title: "Localização com IA",
    description: "Alcance global mais inteligente e rápido com IA. Aproveitando tecnologias de machine learning e tradução neural de ponta para entregar conteúdo localizado de alta qualidade em escala.",
    icon: "Brain"
  },
  {
    id: 2,
    title: "Gestão de Programas",
    description: "Planos claros, execução perfeita. Gestão de programas de localização de ponta a ponta com metodologias comprovadas que garantem a entrega no prazo e no orçamento.",
    icon: "Target"
  },
  {
    id: 3,
    title: "Tradução",
    description: "Palavras precisas, conexões confiáveis. Serviços de tradução profissional que capturam nuances, tom e contexto cultural para uma comunicação global autêntica.",
    icon: "Languages"
  },
  {
    id: 4,
    title: "Formação",
    description: "Competências práticas para o sucesso no mundo real. Programas de formação personalizados que capacitam as equipas com as melhores práticas de localização e tecnologias emergentes.",
    icon: "GraduationCap"
  }
];

export const projects = [
  {
    id: 1,
    title: "AI Polyglots",
    description: "Quebre todas as barreiras linguísticas. Em qualquer lugar. Uma plataforma experimental que permite a comunicação através de barreiras linguísticas usando texto, voz, linguagem gestual e muito mais.",
    image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=600&h=400&fit=crop",
    tags: ["IA", "Tradução", "Acessibilidade"],
    link: "https://aipolyglots.com/",
    featured: true
  },
  {
    id: 2,
    title: "Localização de Marketing Global",
    description: "Liderei a localização de ponta a ponta de campanhas de marketing em mais de 40 idiomas para uma empresa tecnológica da Fortune 500.",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop",
    tags: ["Marketing", "Localização", "Estratégia"],
    link: null,
    featured: false
  },
  {
    id: 3,
    title: "Motor de Tradução IA",
    description: "Implementação e optimização de fluxos de trabalho de tradução automática neural, reduzindo o tempo de colocação no mercado em 60%.",
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=600&h=400&fit=crop",
    tags: ["IA", "NMT", "Optimização"],
    link: null,
    featured: false
  }
];

export const testimonials = [
  {
    id: 1,
    quote: "A Mara é uma das melhores líderes de programa com quem já trabalhei. Ela é altamente estratégica e, ao mesmo tempo, tem um olhar incrível para os detalhes... A sua capacidade de planeamento e execução é inigualável.",
    author: "Justin Mounts",
    role: "Executivo de Marketing Global",
    company: "Ex-HP, Infoblox"
  },
  {
    id: 2,
    quote: "A Mara é uma comunicadora extremamente eficaz... Ela vai consistentemente além na gestão das pessoas e desafia sempre a sua equipa a trabalhar ao máximo do seu potencial.",
    author: "Ernesto Cabanes",
    role: "Líder de Globalização",
    company: "Square"
  }
];

export const stats = [
  { value: "15+", label: "Anos de Experiência" },
  { value: "40+", label: "Idiomas" },
  { value: "50+", label: "Projetos Globais" },
  { value: "100%", label: "Satisfação do Cliente" }
];
